import { fill } from './fill.js'
import { DemoReportCardProgressGr16202307 as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'pgrc1to6_2023_07',
  label: 'Progress Report - Gr. 1-6',
  templateUrl,
  fill,
  Page,
}
